import Inputmask from 'inputmask';

import { MASK_SELECTOR, MASK_CLASS_INITIALIZED } from './mask-constants';
import { maskTypes } from './mask-list';

/**
 * Устанавиливает маску для переданного элемента
 * @param {HTMLInputElement} fieldElement
 */
function initHandler(fieldElement) {
    const { mask } = fieldElement.dataset;
    const maskParams = maskTypes[`${mask}`];

    if (!mask) {
        window.console.info('Не установлен атрибут data-mask', fieldElement);
        return;
    }

    if (!maskParams) {
        window.console.info(`Маска <${mask}> не определена`);
    }

    Inputmask(maskParams)
        .mask(fieldElement);
    fieldElement.classList.add(MASK_CLASS_INITIALIZED.replace('.', ''));
}

/**
 * Инициализирует маски во всем документе
 */
export function initMaskFields() {
    const MASK_SELECTOR_NOT_INITIALIZED = `${MASK_SELECTOR}:not(${MASK_CLASS_INITIALIZED})`;
    const fields = document.querySelectorAll(MASK_SELECTOR_NOT_INITIALIZED);

    if (!fields || !fields.length) {
        return;
    }

    fields.forEach(initHandler);
}
